import { Component, Inject, OnInit } from '@angular/core';
import { DataCreatePersonCompanyProfileApiRequestDto } from '@packages/api-cmd-type-definitions';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle, MatDialogClose } from '@angular/material/dialog';
import { ApiCmdService } from '../../../../services/api-cmd.service';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { HasRoleModule } from '../../../../modules/has-role.module';
import { MatSnackBar } from '@angular/material/snack-bar';
import { handlerSnackbarApiError } from '../../../../utils/snackbar.handler';
import { CONTACT_TYPES, getContactTypesLabel } from '../../../../constants/contact.constants';
import { MatOption, MatSelect } from '@angular/material/select';
import { BUSINESS_ROLES, COUNTRIES, getBusinessRoleTypesLabel, getCountryTypesLabel, getProvinceTypesLabel, PROVINCES } from '../../../../constants/companyProfile.constants';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-company-profile-create-dialog',
  standalone: true,
  imports: [
    MatButton,
    MatDialogActions,
    MatDialogContent,
    MatDialogTitle,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatCheckbox,
    MatIconButton,
    MatIcon,
    NgForOf,
    HasRoleModule,
    MatDialogClose,
    MatSelect,
    MatOption,
    NgIf,
    MatAutocomplete,
    MatAutocompleteTrigger,
    AsyncPipe,
  ],
  templateUrl: './company-profile-create-dialog.component.html',
  styleUrl: './company-profile-create-dialog.component.scss',
})
export class CompanyProfileCreateDialogComponent implements OnInit {
  companyProfileForm: FormGroup;
  contactTypes = CONTACT_TYPES;
  getContactTypesLabel = getContactTypesLabel;
  businessRoles = BUSINESS_ROLES;
  getBusinessRoleTypesLabel = getBusinessRoleTypesLabel;
  provinces = PROVINCES;
  getPronvinceLabel = getProvinceTypesLabel;
  filteredProvinces!: Observable<any[]>;
  countries = COUNTRIES;
  getCountryTypesLabel = getCountryTypesLabel;
  filteredCountries!: Observable<any[]>;
  public isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private apiCmdService: ApiCmdService,
    public dialogRef: MatDialogRef<CompanyProfileCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { personId: string },
    private snackbar: MatSnackBar
  ) {
    this.companyProfileForm = this.fb.group({
      businessRole: ['', Validators.required],
      brand: [''],
      website: [''],
      company: this.fb.group({
        name: ['', Validators.required],
        phone: [''],
        vatNumber: [''],
        agemCode: [''],
        address: [''],
        city: [''],
        province: [''],
        zipCode: [''],
        countryIso2: ['', [Validators.minLength(2), Validators.maxLength(2)]],
        numberEmployees: [''],
        website: [''],
        sales: [''],
      }),
      personContacts: this.fb.array([]),
    });
  }

  ngOnInit(): void {
    this.filteredProvinces = this.companyProfileForm.get('company.province')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterProvinces(value))
    );
    this.filteredCountries = this.companyProfileForm.get('company.countryIso2')!.valueChanges.pipe(
      startWith(''),
      map(value => this._filterCountries(value))
    );
  }

  private _filterProvinces(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.provinces.filter(province => province.label.toLowerCase().includes(filterValue));
  }

  private _filterCountries(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.countries.filter(country => country.label.toLowerCase().includes(filterValue));
  }

  private setterIsSubmitting(value: boolean): () => void {
    return () => {
      this.isSubmitting = value;
    };
  }

  get personContacts(): FormArray {
    return this.companyProfileForm.get('personContacts') as FormArray;
  }

  addContact(): void {
    const contactForm = this.fb.group({
      contactType: ['', Validators.required],
      contactValue: ['', Validators.required],
      isPreferred: [false],
    });
    this.personContacts.push(contactForm);
  }

  removeContact(index: number): void {
    this.personContacts.removeAt(index);
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.companyProfileForm.valid) {
      this.isSubmitting = true;
      const createDto: DataCreatePersonCompanyProfileApiRequestDto['data'] = this.companyProfileForm.value;
      Object.keys(createDto).forEach(key => {
        // @ts-expect-error TS7053
        if (!createDto[key]) createDto[key] = undefined;
      });
      if (createDto.company)
        Object.keys(createDto.company).forEach(key => {
          // @ts-expect-error TS7053
          if (!createDto.company[key]) createDto.company[key] = undefined;
        });
      this.apiCmdService.createPersonCompanyProfile(this.data.personId, { data: createDto }).subscribe({
        next: () => {
          this.isSubmitting = false;
          this.dialogRef.close(true);
        },
        error: err => handlerSnackbarApiError(this.snackbar, err, [this.setterIsSubmitting(false)]),
      });
    }
  }
}
